import { createContext } from "react";
import {
  IPriceAuditLogResponse,
  IPriceAuditStats,
} from "../../models/price-audit/response";
import { IPriceAuditQuery } from "../../models/price-audit/query";

export interface IInternalState {
  loading: string[];
  logs: IPriceAuditLogResponse | null;
  statistics: IPriceAuditStats | null;
  query: IPriceAuditQuery;
}

export interface IExternalState extends IInternalState {
  actions: {
    getLogs: () => Promise<void>;
    getStatistics: () => Promise<void>;
    setQuery: (query: IPriceAuditQuery) => void;
    exportExcel: () => Promise<void>;
    reset: () => void;
  };
}

const defaultState: IExternalState = {
  loading: [],
  logs: null,
  statistics: null,
  query: {
    page: 1,
    per_page: 10,
  },
  actions: {
    getLogs: async () => {},
    getStatistics: async () => {},
    setQuery: () => {},
    exportExcel: async () => {},
    reset: () => {},
  },
};

const PriceAuditContext = createContext<IExternalState>(defaultState);

export default PriceAuditContext;
